/* jshint esversion: 6 */
import React from 'react';
import DropDownModule from 'app/mixins/DropDownModule.js';
import classnames from 'classnames';

class NavigationItem extends React.Component {
	constructor(props) {
		super(props);

		this.clickHandler = this.clickHandler.bind(this);
	}

	clickHandler(action, e) {
		this.props.clickHandler(action, e);
	}

	render() {

		var iconClassNames = 'btn-icon ' + this.props.item.icon,
			itemClass = classnames('navigation-option',
				{
					'active-item': this.props.itemActive
				}
			);

		return (
			<li className={itemClass}
				onClick={this.clickHandler.bind(this, this.props.item.action)}
				onTouchStart={this.clickHandler.bind(this, this.props.item.action)}>
				<div className="navigation-label">
					<i className={iconClassNames}></i>
					{this.props.item.label}
				</div>
			</li>
		);

	}

};

export default DropDownModule(NavigationItem);
